import React from 'react';

import TagTile from 'components/Tiles/TagTile';
import { TagTileProps } from 'components/Tiles/TagTile/TagTile';

import ShowTile from 'components/Tiles/ShowTile';
import { ShowTileProps } from 'components/Tiles/ShowTile/ShowTile';

import Promotion from 'components/Promotion';
import { PromotionProps } from 'components/Promotion/Promotion';
import OnDemandTile from 'components/Tiles/OnDemandTile';
import PodcastTile from 'components/Tiles/PodcastTile';
import { PodcastTileProps } from 'components/Tiles/PodcastTile/PodcastTile';

import Card from 'components/CardDeck/Card';
import MixedContentItem from 'components/MixedContentItem';

import withGraphqlData from 'components/hoc/withGraphqlData';

import { TILE_COMPONENT_TYPES } from './TileComponent.const';
import StationTile from 'components/Tiles/StationTile';
import { DefaultProps } from 'components/Tiles/StationTile/StationTileContainer';

type TileComponentProps = {
  tileComponent: string;
  display: string;
  index?: number;
};

const TileComponent = ({ tileComponent, ...props }: TileComponentProps): JSX.Element => {
  switch (tileComponent) {
    case TILE_COMPONENT_TYPES.STATION:
      return <StationTile {...((props as unknown) as DefaultProps)} />;

    case TILE_COMPONENT_TYPES.RECENTLY_PLAYED_STATION:
      const Component = withGraphqlData(StationTile);
      return <Component {...props} />;

    case TILE_COMPONENT_TYPES.PODCAST:
      return <PodcastTile {...((props as unknown) as PodcastTileProps)} />;

    case TILE_COMPONENT_TYPES.ON_DEMAND:
      return <OnDemandTile {...props} />;

    case TILE_COMPONENT_TYPES.PROMOTION:
      return <Promotion {...((props as unknown) as PromotionProps)} />;

    case TILE_COMPONENT_TYPES.SHOW:
      return <ShowTile {...((props as unknown) as ShowTileProps)} />;

    case TILE_COMPONENT_TYPES.TAG:
      return <TagTile {...((props as unknown) as TagTileProps)} />;

    case TILE_COMPONENT_TYPES.CARD:
      return <Card {...props} />;

    case TILE_COMPONENT_TYPES.MIXED_CONTENT:
      return <MixedContentItem {...props} />;

    case TILE_COMPONENT_TYPES.MIXED_CONTENT_WITH_HOC:
      const MixedContentItemWithHOC = withGraphqlData(MixedContentItem);
      return <MixedContentItemWithHOC {...props} />;

    default:
      return null;
  }
};

export default TileComponent;
